export default "__VITE_ASSET__3ac83f13__"